import { safeDefine } from "../../registration/safe-define.js";
import { TimeSeparatorElement } from "../../ui/time/separator.js";
//#region src/define/ui/time-separator.ts
safeDefine(TimeSeparatorElement);
//#endregion

//# sourceMappingURL=time-separator.js.map